import * as ChannelService from '@channel.io/channel-web-sdk-loader'
import { useEffect } from 'react'
import type { ReactElement } from 'react'
import ReactPixel from 'react-facebook-pixel'

import { toggleTab } from './utils/toggleTab'

import { useUserInfo } from './hooks/useUserInfo'

import 'pretendard/dist/web/static/pretendard.css'
import './theme/action-sheet.css'
import './theme/custom.css'

const CHANNEL_KEY = '759b1739-ca8c-41ac-b2b7-6a6668761bd0'
const PIXEL_ID = '926526585896952'

ChannelService.loadScript()

export function App({ children }: { children: ReactElement }) {
  const { isLoading } = useUserInfo()

  useEffect(() => {
    console.log('App mount')

    // 유저 정보 확인과 채널톡 서비스 연결
    ChannelService.boot({ pluginKey: CHANNEL_KEY })

    // 수동 연동 Meta Pixel 초기화 코드
    ReactPixel.init(PIXEL_ID, undefined, { autoConfig: true, debug: true })
    ReactPixel.pageView()
  }, [])

  // location이 바뀔 때 마다 하단 탭 active 체크
  useEffect(() => {
    const pathname = location.pathname
    toggleTab(pathname)
  }, [location])

  return isLoading ? null : children
}
